import { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { primaryColor } from '../styles/colors'

export type ButtonProps = {
  children: ReactNode
  onClick: () => void | Promise<void>
  buttonType: 'contained' | 'outlined' | 'text' | 'icon'
  disabled?: boolean
  isSubmit?: boolean
  isFullWidth?: boolean
}
export const Button: FC<ButtonProps> = (props) => {
  const { onClick, children, buttonType, disabled = false, isSubmit, isFullWidth = false } = props
  const handleClick = () => {
    if (disabled) return
    onClick()
  }
  return (
    <StyledButton
      onClick={handleClick}
      buttonType={buttonType}
      disabled={disabled}
      isFullWidth={isFullWidth}
      type={isSubmit ? 'submit' : 'button'}
    >
      {children}
    </StyledButton>
  )
}

const StyledButton = styled.button<ButtonProps>`
  outline: none;
  border-radius: 10px;
  font-size: 16px;
  padding: 8px 20px;
  cursor: pointer;
  transition: 0.2s;

  ${({ buttonType }) =>
    buttonType === 'contained'
      ? css`
          ${primaryColor.backgrond}
          color: #fff;
          ${primaryColor.border}
          &:hover {
            background: #fff;
            ${primaryColor.color}
          }
        `
      : buttonType === 'text'
      ? css`
          background: #fff;
          ${primaryColor.color}
          border: 1px solid transparent;
          border-radius: 5px;
          &:hover {
            background: #f3fff0;
          }
        `
      : buttonType === 'outlined'
      ? css`
          background: #fff;
          ${primaryColor.color}
          ${primaryColor.border}
          &:hover {
            ${primaryColor.backgrond}
            color: #fff;
          }
        `
      : buttonType === 'icon' &&
        css`
          background: none;
          border: 1px solid transparent;
          padding: 7px;
          border-radius: 5px;
          &:hover {
            background: #fafafa;
          }
        `}
`
